import React from 'react'

import { withRouter } from 'react-router-dom'

import { Button, Dimmer, Form, Header, Icon, Message, Modal } from 'semantic-ui-react';

import { FormWrapper, Input } from 'components';

import './style.css';

import { API } from 'services';

class UserPasswordConfirmScene extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      success: false,
      actions: {
        submit: {
          name: "Enregistrer",
          callback: this.handleSubmit
        }
      }
    };
  }

  componentDidMount() {

    let params = new URLSearchParams(window.location.search);

    if (!params.has('token')) {
      this.props.history.push('/');
    }

    this.setState({
      token: params.get('token')
    });
  }

  handleClose() {
    this.props.history.push('/');
  }

  handleSubmit(data, onSucess, onError) {

    console.log(data);

    if(data.password !== data.confirm_password) {

      onError({
        password: [
          'Les mots de passe ne correspondent pas'
        ],
        confirm_password: []
      });

      return
    }

    this.setState({
      failure: false
    }, () => {

      //Remove password confirmation check
      delete data.confirm_password;

      // Adding token to data to be sent
      data.token = this.state.token;

      API.post('/users/password/confirm', data)
        .then(() => {

          this.setState({
            success: true
          });

        })
        .catch((error) => {
          onError(API.violations(error));

          if(error.response.status === 404) {

            this.setState({
              failure: true
            });
          }

        });
    })
  }

  render() {

    return (
      <Modal id="user-activation" open size='small' dimmer="blurring">
        <Header icon="unlock" content="Changement du mot de passe" />
        <Modal.Content>

          {/* <FormWrapper> */}
          <Dimmer.Dimmable blurring dimmed={this.state.success}>
            <Dimmer active={this.state.success} inverted />

            {this.state.failure &&
              <Message error>
                Une erreur est survenue lors du traitement de votre demande
              </Message>
            }

            <FormWrapper actions={this.state.actions}>

              {/* Password */}
              <Form.Field>
                <label htmlFor="password" className="required">Mot de passe</label>
                <Input id="password" name="password" type="password" autoComplete="off" />
              </Form.Field>

              {/* Confirm password */}
              <Form.Field>
                <label htmlFor="confirm_password" className="required">Confirmation du mot de passe</label>
                <Input id="confirm_password" name="confirm_password" type="password" autoComplete="off" />
              </Form.Field>

            </FormWrapper>

          </Dimmer.Dimmable>

          {/* Success */}
          {this.state.success &&
            <div className="overlay">
              <Icon name="checkmark" size="huge" color="green" />
              <span>Les modifications ont bien été enregistrées</span>
              <Button color="green" onClick={this.handleClose}>Fermer</Button>
            </div>
          }

        </Modal.Content>
      </Modal>
    );
  }
}

export default withRouter(UserPasswordConfirmScene);
